var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPieChart = function SvgPieChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgPieChart",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgPieChart{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    className: "svgPieChart svgBase svgHover svgSelect",
    d: "M17.2,8.4H9.6V0.8c0-0.3-0.3-0.6-0.6-0.6c-4.9,0-8.8,4-8.8,8.8s4,8.8,8.8,8.8s8.8-4,8.8-8.8 C17.8,8.7,17.6,8.4,17.2,8.4z M9,16.7c-4.2,0-7.6-3.4-7.6-7.7c0-4,3.1-7.3,7.1-7.6V9c0,0.3,0.3,0.6,0.6,0.6h7.6 C16.3,13.6,13,16.7,9,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    className: "svgPieChart svgBase svgHover svgSelect",
    d: "M17.5,6.6c0-0.1,0-0.1-0.1-0.2c-0.9-2.8-3.1-4.9-5.8-5.8c-0.1,0-0.2,0-0.2,0 c-0.3,0-0.6,0.3-0.6,0.6c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0.1c2.4,0.8,4.3,2.6,5,5.1l0,0.1c0.1,0.3,0.5,0.5,0.8,0.4 C17.3,7.1,17.5,6.9,17.5,6.6C17.5,6.6,17.5,6.6,17.5,6.6z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie_chart.0006deb2.svg";
export { ForwardRef as ReactComponent };